
import { BasicModel } from "@goodgamestudios/core";
import { SFConstants } from "../../constants/SFConstants";
import { Poker2AchievementStatsEvent } from "../../event/Poker2AchievementStatsEvent";
import { Poker2DialogEvent } from "../../event/Poker2DialogEvent";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2ProfilTabAchievement } from "../components/playerprofil/Poker2ProfilTabAchievement";
import { Poker2ProfilTabStats } from "../components/playerprofil/Poker2ProfilTabStats";
import { Poker2ProfilDialogProperties } from "../dialogs/Poker2ProfilDialogProperties";
import { Poker2Screen } from "./Poker2Screen";

import DisplayObject = createjs.DisplayObject;
import MouseEvent = createjs.MouseEvent;

export class Poker2AchivementStatsScreen extends Poker2Screen {
    public static NAME: string = "Poker2AchivementStatsScreen";

    private X_POS: number = 133;
    private Y_POS: number = 307;

    private profilProperties: Poker2ProfilDialogProperties;
    private tabAchievement: Poker2ProfilTabAchievement;
    private tabStats: Poker2ProfilTabStats;

    constructor(disp: DisplayObject) {
        CONSTRUCTOR_HACK;
        super(disp);
    }
    protected init(): void {
        super.init();
        this.rankingScreen.btn_close.visible = false;
        this.tabAchievement = new Poker2ProfilTabAchievement(this.rankingScreen.mc_achievement);
        this.tabStats = new Poker2ProfilTabStats(this.rankingScreen.mc_statistics);
        this.controller.addEventListener("changeTabAchievements", this.bindFunction(this.onChangeAchievements));
        this.controller.addEventListener("changeTabStatistics", this.bindFunction(this.onChangeStatistics));

        this.rankingScreen.bg.doCache(0, 2);
    }
    protected applyProperties(): void {
        super.applyProperties();
        this.rankingScreen.btn_statistics.toolTipText = Poker2Model.languageData.getTextById("menu_btn_statistics");
        this.rankingScreen.btn_achievement.toolTipText = Poker2Model.languageData.getTextById("menu_btn_achievements");

        this.tabStats.applyProperties();
        this.tabAchievement.applyProperties();

    }

    public show(): void {
        super.show();
        this.tabAchievement.show();
    }

    private changeTab(tabIndex: number): void {
        this.rankingScreen.mc_statistics.visible = (tabIndex == 2);
        this.rankingScreen.mc_achievement.visible = (tabIndex == 1);

        this.controller.dispatchEvent(new Poker2DialogEvent("menueselection", ["Poker2AchivementStatsScreen" + "_" + 2, (tabIndex == 2) ? 1 : 0]));
        this.controller.dispatchEvent(new Poker2DialogEvent("menueselection", ["Poker2AchivementStatsScreen" + "_" + 1, (tabIndex == 1 ? 1 : 0)]));

        if (tabIndex == 2) {
            this.rankingScreen.btn_achievement.deselected();
            this.rankingScreen.btn_statistics.selected();
            this.tabStats.fillPlayerStatistics(this.profilProperties.playerProfile, this.profilProperties.playerId);
        }
        else {
            this.rankingScreen.btn_achievement.selected();
            this.rankingScreen.btn_statistics.deselected();
            this.tabAchievement.changeAchievementPage(0);
        }
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);

        switch (event.target) {
            case this.rankingScreen.btn_achievement:
                this.getAchievementStats();
                break;
            case this.rankingScreen.btn_statistics:
                this.getUserStats();
                break;
            case this.rankingScreen.mc_achievement.btn_up:
                this.tabAchievement.onClick(event);
                break;
            case this.rankingScreen.mc_achievement.btn_down:
                this.tabAchievement.onClick(event);
                break;
        }
    }

    private getUserStats(): void {
        var paramObject: any = { id: this.profilProperties.playerId };
        BasicModel.smartfoxClient.sendMessage("gpp", [JSON.stringify(paramObject)]);
    }

    private getAchievementStats(): void {
        var paramObject: any = { id: this.profilProperties.playerId };
        BasicModel.smartfoxClient.sendMessage("ali", [JSON.stringify(paramObject)]);
    }

    public hide(): void {
        this.tabAchievement.hide();
        this.controller.dispatchEvent(new Poker2DialogEvent("menueselection", ["Poker2AchivementStatsScreen" + "_" + 2, 0]));
        this.controller.dispatchEvent(new Poker2DialogEvent("menueselection", ["Poker2AchivementStatsScreen" + "_" + 1, 0]));
        super.hide();
    }

    public destroy(): void {
        super.destroy();
        this.controller.removeEventListener("changeTabAchievements", this.bindFunction(this.onChangeAchievements));
        this.controller.removeEventListener("changeTabStatistics", this.bindFunction(this.onChangeStatistics));
    }

    private onChangeAchievements(event: Poker2AchievementStatsEvent): void {
        this.profilProperties = event.params[0] as Poker2ProfilDialogProperties;
        this.changeTab(this.profilProperties.tabIndex);
    }

    private onChangeStatistics(event: Poker2AchievementStatsEvent): void {
        this.profilProperties = event.params[0] as Poker2ProfilDialogProperties;
        this.changeTab(this.profilProperties.tabIndex);
    }

    public updatePosition(): void {
        if (this.disp && this.disp.stage) {
            this.disp.scaleX = this.disp.scaleY = this.layoutManager.scaleFactor;
            this.disp.x = ((800 / 2 + this.X_POS) * this.disp.scaleX) + this.layoutManager.gameNullPoint;
            this.disp.y = (this.Y_POS * this.layoutManager.scaleFactor);
        }
    }

    public get rankingScreen(): Library.PokerInterface.PokerProfil {
        return this.disp as Library.PokerInterface.PokerProfil;
    }
}
import { Poker2LayoutManager } from "../Poker2LayoutManager";
